module.exports = __webpack_public_path__ + "d8514c0fa57f9e4a82a83234d4138cff.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg13.jpeg
// module id = 21
// module chunks = 0